import { useParams } from 'react-router-dom';
import { Page } from '../../components/Page';

/**
 * Textos legales base. DEBEN ser revisados por un abogado dominicano antes de
 * producción (Ley 172-13 sobre protección de datos personales).
 */
const DOCS: Record<string, { title: string; body: string[] }> = {
  privacidad: {
    title: 'Política de privacidad',
    body: [
      'TuConductorRD recopila los datos necesarios para prestar el servicio de transporte privado: nombre, teléfono, correo, fotografía de perfil (opcional), direcciones de recogida y destino, historial de viajes, mensajes con tu conductor y registros de pago.',
      'La ubicación GPS del conductor se comparte contigo únicamente durante un viaje activo (desde "Conductor en camino" hasta "Viaje finalizado"). No rastreamos al conductor ni a los clientes fuera de ese contexto.',
      'Tu fotografía y nombre se muestran al conductor asignado para facilitar la recogida. No vendemos ni compartimos tus datos con terceros con fines publicitarios.',
      'Proveedores que procesan datos en nuestro nombre: nuestro propio servidor (incluidos los servicios de rutas y direcciones basados en OpenStreetMap), OpenFreeMap (imágenes del mapa, sin datos personales), Firebase Cloud Messaging (notificaciones), Meta WhatsApp Cloud API (si nos escribes por WhatsApp) y el proveedor de correo electrónico.',
      'Conservación: los puntos GPS de un viaje se borran 90 días después de terminado; las notificaciones leídas, a los 180 días. Los viajes y pagos se conservan como registro contable.',
      'Puedes corregir tus datos desde tu perfil y eliminar tu cuenta en Cuenta → Eliminar mi cuenta. Al eliminarla se borran tu nombre, correo, teléfono, foto y direcciones; los viajes y pagos se conservan sin tus datos personales, como exige la contabilidad. También puedes escribir al contacto del negocio.',
      'Conforme a la Ley 172-13 de la República Dominicana sobre protección integral de datos personales.',
    ],
  },
  /** Página pública para Google Play: cómo eliminar la cuenta y qué datos se borran. */
  'eliminar-cuenta': {
    title: 'Eliminar tu cuenta',
    body: [
      'Puedes eliminar tu cuenta de TuConductorRD en cualquier momento desde la app o la web: inicia sesión, entra en Perfil (clientes) o Más (conductores) y toca el botón rojo "Eliminar mi cuenta". Confirma con tu contraseña o, si entraste con Google, escribiendo ELIMINAR.',
      'Si no puedes entrar a tu cuenta, escríbenos por WhatsApp o al correo del negocio desde el correo registrado y la eliminaremos en un plazo máximo de 30 días.',
      'Se borran de inmediato: nombre, correo, teléfono, foto de perfil, direcciones guardadas, preferencias, notificaciones y dispositivos de notificación, y se cierran todas tus sesiones.',
      'Se conservan sin tus datos personales: los viajes y pagos, como registro contable exigido por ley. Los puntos GPS de los viajes se borran 90 días después de terminado cada viaje.',
    ],
  },
  terminos: {
    title: 'Términos del servicio',
    body: [
      'TuConductorRD conecta clientes con su conductor privado. Cada viaje requiere una cotización del conductor que el cliente debe aceptar expresamente antes de confirmarse.',
      'El precio pactado no se modifica sin tu aceptación. Los cambios de ruta, fecha o servicio que alteren el precio requieren una nueva cotización.',
      'El pago se realiza directamente al conductor en efectivo o transferencia. Solo el conductor confirma la recepción del dinero; el cliente puede reportar un pago o una discrepancia.',
      'Las propinas son voluntarias y nunca se agregan automáticamente.',
      'Las cancelaciones se rigen por la política publicada por el negocio en el momento de la reserva.',
    ],
  },
};

export function LegalPage() {
  const { doc } = useParams<{ doc: string }>();
  const d = DOCS[doc] ?? DOCS.terminos!;
  return (
    <Page title={d.title} back="/">
      <article className="prose max-w-none flex flex-col gap-4 text-[15px] leading-relaxed">
        {d.body.map((p, i) => (
          <p key={i}>{p}</p>
        ))}
        <p className="text-xs text-[var(--text-muted)]">Documento base pendiente de revisión legal.</p>
      </article>
    </Page>
  );
}
